"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneIncomingCallSmallFillNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneIncomingCallSmallFillNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.225 9.313h1.025c.966 0 1.75.783 1.75 1.75v1.312A2.635 2.635 0 0 1 12.355 15C6.082 14.99 1 9.9 1 3.625A2.625 2.625 0 0 1 3.625 1h1.312c.967 0 1.75.784 1.75 1.75v1.025c0 .464-.184.91-.512 1.238l-.918.918a.654.654 0 0 0-.15.707 7.888 7.888 0 0 0 4.255 4.255c.242.1.522.035.707-.15l.918-.918a1.75 1.75 0 0 1 1.238-.512Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.853 1.146a.5.5 0 0 0-.707 0L10 5.293V2a.5.5 0 0 0-1 0v4.5a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 0-1h-3.293l4.146-4.146a.5.5 0 0 0 0-.708Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneIncomingCallSmallFillNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneIncomingCallSmallFillNo;
exports["default"] = _default;